export const environment = {
  lang: "de",
  url: "https://urlaubscountdown.de/",
  api: "https://api.urlaubscountdown.de/",
};
